var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Layout, Dependencies } from "~/core/decorator";
import { PageService } from "~/utils/page.service";
import { SortService } from "~/utils/sort.service";
import NumberRange from "~/components/common/number-range.vue";
import { OutsourceLawsuitBackService } from "~/services/domain-service/outsource-lawsuit-back-manage.service";
import { OutsourceLawsuitService } from "~/services/domain-service/outsource-lawsuit-manage-index.service";
import { namespace } from "vuex-class";
var CollectionExecutionModule = namespace("collection-execution");
// @Auth(1012)
var OutsourceLawsuitBackManageIndex = /** @class */ (function (_super) {
    __extends(OutsourceLawsuitBackManageIndex, _super);
    function OutsourceLawsuitBackManageIndex() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isCheck = false;
        _this.dataList = [];
        _this.selectionList = [];
        _this.caseIds = [];
        _this.lawsuitId = {};
        _this.dialog = {
            setCaseDetail: false
        };
        // form 查询表单参数
        _this.queryModel = {
            batchNumber: "",
            caseNumber: "",
            personalName: "",
            mobileNo: "",
            idCard: "",
            localAddress: "",
            currentCollector: "",
            overduePeriod: "",
            turnSource: "",
            productCategory: "",
            productName: "",
            followInTime: "",
            outAmount: {
                max: "",
                min: ""
            },
            overdueDays: {
                max: "",
                min: ""
            }
        };
        _this.active = 0;
        _this.lawsuitObj = {};
        _this.stepDate = [
            { step: "LAWSUIT_TPYE", active: -1 },
            { step: "COURT", active: 0 },
            { step: "CHECK", active: 1 },
            { step: "COURT_EXECUTE", active: 2 },
            { step: "EXECUTION", active: 3 },
            { step: "END", active: 4 },
            { step: "TAKE", active: 5 } // 参与分配
        ];
        _this.followType = {};
        _this.stepType = {
            lawsuitFollowType: "",
            lawsuitObj: _this.lawsuitObj
        };
        return _this;
    }
    OutsourceLawsuitBackManageIndex.prototype.mounted = function () {
        this.refreshData();
    };
    /**
     * 查询列表
     */
    OutsourceLawsuitBackManageIndex.prototype.refreshData = function () {
        var _this = this;
        this.outsourceLawsuitBackService
            .searchLawsuitRecoveryList(this.queryModel, this.pageService, this.sortService)
            .subscribe(function (data) {
            _this.dataList = data;
        });
    };
    OutsourceLawsuitBackManageIndex.prototype.moveToStay = function () {
        var _this = this;
        if (this.selectionList.length === 0) {
            this.$message.info("请选择要回收的案件");
            return;
        }
        this.caseIds = [];
        this.selectionList.map(function (v) {
            _this.caseIds.push(v.id);
        });
        this.outsourceLawsuitBackService
            .moveLawsuitWait({ caseIds: this.caseIds })
            .subscribe(function (data) {
            _this.$message.success("案件分配成功");
            _this.refreshData();
        });
    };
    OutsourceLawsuitBackManageIndex.prototype.checkFllow = function () { };
    OutsourceLawsuitBackManageIndex.prototype.litigationFollow = function (row) {
        this.lawsuitObj = row;
        // this.dialog.litigationFollow = true;
        this.getStep(); //查询步骤
    };
    /**
     * 获取步骤
     */
    OutsourceLawsuitBackManageIndex.prototype.getStep = function () {
        var _this = this;
        this.outsourceLawsuitService
            .getCourtInfoStep({ id: this.lawsuitObj.id })
            .subscribe(function (data) {
            _this.active = -1;
            _this.stepDate.map(function (v) {
                if (v.step === data) {
                    _this.active = v.active;
                }
            });
            if (_this.active !== -1) {
                _this.getFllowInfo();
                _this.dialog.setCaseDetail = true;
                _this.isCheck = true;
            }
        });
    };
    OutsourceLawsuitBackManageIndex.prototype.getFllowInfo = function () {
        // this.outsourceLawsuitService.getFollowInfo({id:this.lawsuitObj.id}).subscribe(
        //   data => {
        //     if(data){
        //       // this.dialog.setUpForce = true
        //       this.followType = this.lawsuitObj;
        //       this.followType.lawsuitFollowType = data.lawsuitFollowType
        //     }
        //   },
        //   ({ msg }) => {
        //   }
        // );
    };
    /**
     * 进入查看执行页
     */
    OutsourceLawsuitBackManageIndex.prototype.openExecutionPage = function (row) { };
    /**
     * 重置numberRange
     */
    OutsourceLawsuitBackManageIndex.prototype.follFeedback = function () {
        this.queryModel.overdueAmount = { max: "", min: "" };
        this.queryModel.overdueDays = { max: "", min: "" };
    };
    __decorate([
        Dependencies(OutsourceLawsuitBackService)
    ], OutsourceLawsuitBackManageIndex.prototype, "outsourceLawsuitBackService", void 0);
    __decorate([
        Dependencies(PageService)
    ], OutsourceLawsuitBackManageIndex.prototype, "pageService", void 0);
    __decorate([
        Dependencies(SortService)
    ], OutsourceLawsuitBackManageIndex.prototype, "sortService", void 0);
    __decorate([
        Dependencies(OutsourceLawsuitService)
    ], OutsourceLawsuitBackManageIndex.prototype, "outsourceLawsuitService", void 0);
    __decorate([
        CollectionExecutionModule.Action
    ], OutsourceLawsuitBackManageIndex.prototype, "openCollectionExecution", void 0);
    OutsourceLawsuitBackManageIndex = __decorate([
        Layout("workspace"),
        Component({
            components: {
                NumberRange: NumberRange
            }
        })
    ], OutsourceLawsuitBackManageIndex);
    return OutsourceLawsuitBackManageIndex;
}(Vue));
export default OutsourceLawsuitBackManageIndex;
